import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { redirect } from 'redux-first-router';
import _ from 'lodash';

import * as Actions from '../../redux/actions';
import { auth } from '../../lib/auth';
import logo from '../../images/logo_nav.svg';
import SelectOrganization from '../Components/SelectOrganization';
import StatesPieChart from './Dashboard/StatesPieChart';
import StatesTable from './Dashboard/StatesTable';
import ActiveFindingsTable from './Dashboard/ActiveFindingsTable';
import Worldmap from './Dashboard/Worldmap';
import LocationsTable from './Dashboard/LocationsTable';
import TrendsGraph from './Dashboard/TrendsGraph';

const AUTOMATIC_REFRESH = false;
const REFRESH_TIME = 5 * 1000 * 60; // 5 mins

class TVModePageView extends Component {
  constructor(props) {
    super(props);

    this.fetch = this.fetch.bind(this);
    this.retryDataQuery = this.retryDataQuery.bind(this);
    this.routeToOrg = this.routeToOrg.bind(this);
    this.exitTVMode = this.exitTVMode.bind(this);
    this.logout = this.logout.bind(this);
  }

  componentDidMount() {
    this.fetch();
    if (AUTOMATIC_REFRESH) {
      this.periodicFetchInterval  = setInterval(this.fetch, REFRESH_TIME);
    }
  }

  componentDidUpdate(prevProps) {
    let fetch = false;
    if (prevProps.orgId !== this.props.orgId) {
      fetch = true;
    } else if (!_.isEqual(prevProps.payload, this.props.payload)) {
      fetch = true;
    }
    if (fetch) this.fetch();
  }

  componentWillUnmount() {
    clearInterval(this.periodicFetchInterval);
  }

  fetch() {
    const { dispatch, orgId, user } = this.props;
    dispatch(Actions.DataQuery.processDataQueries(orgId));
    dispatch(Actions.Findings.fetchFindings({
      personId: user.id,
      orgId,
    }));
  }

  retryDataQuery(dataQueryKey) {
    const { dispatch, orgId } = this.props;
    dispatch(Actions.DataQuery.processDataQueries(orgId, dataQueryKey));
  }

  routeToOrg(orgId) {
    const {
      routeToOrg,
      payload = {},
      query = {},
    } = this.props;

    routeToOrg({
      type: 'PAGE',
      payload: { ...payload, orgId },
      query: { ...query },
    });
  }

  exitTVMode() {
    // returns to analyst page by default
    const {
      dispatch,
      payload = {},
    } = this.props;

    dispatch(redirect({
      type: 'PAGE',
      payload: {
        ...payload,
        toplevel: 'dashboard',
        secondlevel: 'analyst',
      },
    }));
  }

  logout() {
    const { routeToLogin } = this.props;
    auth.logout().then(() => {
      routeToLogin();
    });
  }

  render() {
    const {
      orgName = '',
      payload = {},
    } = this.props;

    const { dataQueries = {} } = this.props;

    const scrollerStats = dataQueries.DASHBOARD_SCROLLER_STATS.visualizationData;

    const {
      eventsDetectedAndAnalyized = 0,
      suspectsIdentifiedAndFiltered = 0,
      threatsIdentified = 0,
    } = scrollerStats;

    return (
      <div className='tv-mode'>

        <div className='action-bar row no-gutters'>
          <div className='col-1'>
            <img
              src={logo}
              alt='Logo'
              className='logo'
            />
          </div>
          <div className='col-1 org-dropdown'>
            <SelectOrganization
              orgName={orgName}
              orgId={payload.orgId}
              routeToOrg={this.routeToOrg}
            />
          </div>
          <div className='col-10 action-buttons'>
            <Button className='exit' onClick={this.exitTVMode}>Exit TV Mode</Button>
            <Button className='logout' onClick={this.logout}>Logout</Button>
          </div>
        </div>

        <div className='tv-stats row no-gutters'>
          <div className='col-4'>
            <h2>{eventsDetectedAndAnalyized}</h2>
            <h3>Events Detected and Analyzed</h3>
          </div>
          <div className='col-4'>
            <h2>{suspectsIdentifiedAndFiltered}</h2>
            <h3>Suspects Identified and Filtered</h3>
          </div>
          <div className='col-4'>
            <h2>{threatsIdentified}</h2>
            <h3>Threats Identified</h3>
          </div>
        </div>

        <div className='grid-wrapper'>
          <div className='grid-box a'>
            <div className='data-viz'>
              <div className='title'>Finding States</div>
              <StatesPieChart
                chartData={dataQueries.DASHBOARD_PIE_CHART}
                handleRetry={() => {
                  this.retryDataQuery('DASHBOARD_PIE_CHART');
                }}
              />
            </div>
          </div>
          <div className='grid-box b'>
            <div className='data-viz'>
              <div className='title'>Threats Detected</div>
              <StatesTable
                tableData={dataQueries.DASHBOARD_RECENT_THREATS_TABLE}
                handleRetry={() => {
                  this.retryDataQuery('DASHBOARD_RECENT_THREATS_TABLE');
                }}
              />
            </div>
          </div>
          <div className='grid-box c'>
            <div className='data-viz'>
              <div className='title'>Current Active Findings</div>
              <ActiveFindingsTable
                tableData={dataQueries.DASHBOARD_CURRENT_ACTIVE_FINDINGS_TABLE}
                compactStyle
                handleRetry={() => {
                  this.retryDataQuery('DASHBOARD_CURRENT_ACTIVE_FINDINGS_TABLE');
                }}
              />
            </div>
          </div>
          <div className='grid-box d'>
            <div className='data-viz'>
              <div className='title'>Finding Source Locations</div>
              <Worldmap
                mapData={dataQueries.DASHBOARD_WORLD_MAP}
                handleRetry={() => {
                  this.retryDataQuery('DASHBOARD_WORLD_MAP');
                }}
              />
            </div>
          </div>
          <div className='grid-box e'>
            <div className='data-viz'>
              <div className='title'>Threats Detected</div>
              <TrendsGraph
                trendData={dataQueries.DASHBOARD_FINDINGS_TREND}
                graphData={dataQueries.DASHBOARD_FINDINGS_DETECTED_GRAPH}
                colorPallete={1}
                type='threats'
                handleRetry={() => {
                  this.retryDataQuery('DASHBOARD_FINDINGS_TREND');
                  this.retryDataQuery('DASHBOARD_FINDINGS_DETECTED_GRAPH');
                }}
              />
            </div>
          </div>
          <div className='grid-box f'>
            <div className='data-viz'>
              <div className='title'>Finding Source Locations</div>
              <LocationsTable
                tableData={dataQueries.DASHBOARD_LOCATIONS_TABLE}
                defaultPageSize={5}
                handleRetry={() => {
                  this.retryDataQuery('DASHBOARD_LOCATIONS_TABLE');
                }}
              />
            </div>
          </div>
          <div className='grid-box g'>
            <div className='data-viz'>
              <div className='title'>Suspects Opened</div>
              <TrendsGraph
                trendData={dataQueries.DASHBOARD_FINDINGS_TREND}
                graphData={dataQueries.DASHBOARD_FINDINGS_DETECTED_GRAPH}
                type='suspects'
                handleRetry={() => {
                  this.retryDataQuery('DASHBOARD_FINDINGS_TREND');
                  this.retryDataQuery('DASHBOARD_FINDINGS_DETECTED_GRAPH');
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TVModePageView.propTypes = {
  dataQueries: PropTypes.shape({}),
  payload: PropTypes.shape({}),
  query: PropTypes.shape({}),
  orgId: PropTypes.string,
  orgName: PropTypes.string,
  routeToOrg: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.shape({}),
  routeToLogin: PropTypes.func.isRequired,
};

TVModePageView.defaultProps = {
  dataQueries: {},
  payload: {},
  query: {},
  user: {},
  orgId: '',
  orgName: 'Unknown',
};

export default TVModePageView;



// WEBPACK FOOTER //
// ./src/views/Pages/TVModePageView.js